import React from 'react';

import styled from 'styled-components';

interface PageWrapperProps {
  children: React.ReactNode;
}

const PageContainer = styled.div`
  margin: auto;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px 104px;
  @media (max-width: 1240px) {
    margin: 0 24px;
  }
`;

function PageWrapper({ children }: PageWrapperProps) {
  return (
    <div style={{ height: '100%' }}>
      <PageContainer>{children}</PageContainer>
    </div>
  );
}

export default PageWrapper;
